module.exports = __webpack_public_path__ + "static/media/naver-cafe-icon.94804050.png";